import io from 'socket.io-client'

const socket = io.connect(
  'https://react-lucky-server-e88da0a4b9f6.herokuapp.com'
)

export default socket
